import type { SportProfile } from '@/types'

export const basketballMens: SportProfile = {
  id: 'basketball-mens',
  sport: 'basketball',
  gender: 'mens',
  environment: 'court',
  label: "Men's Basketball",
  emoji: '🏀',
  playersOnField: 5,
  contactLevel: 'limited',
  hasShotClock: true,
  shotClockSeconds: 30,
  periods: { label: 'Quarter', count: 4, durationMinutes: 8 },
  positions: [
    { key: 'point_guard',     label: 'Point Guard',     shortLabel: 'PG' },
    { key: 'shooting_guard',  label: 'Shooting Guard',  shortLabel: 'SG' },
    { key: 'small_forward',   label: 'Small Forward',   shortLabel: 'SF' },
    { key: 'power_forward',   label: 'Power Forward',   shortLabel: 'PF' },
    { key: 'center',          label: 'Center',          shortLabel: 'C'  },
  ],
  stats: [
    { key: 'two_pointer',   label: '2-Point FG',     shortLabel: '2P'  },
    { key: 'three_pointer', label: '3-Point FG',     shortLabel: '3P'  },
    { key: 'free_throw',    label: 'Free Throw',     shortLabel: 'FT'  },
    { key: 'rebound_off',   label: 'Off. Rebound',   shortLabel: 'OR'  },
    { key: 'rebound_def',   label: 'Def. Rebound',   shortLabel: 'DR'  },
    { key: 'assist',        label: 'Assist',          shortLabel: 'AST' },
    { key: 'steal',         label: 'Steal',           shortLabel: 'STL' },
    { key: 'block',         label: 'Block',           shortLabel: 'BLK' },
    { key: 'turnover',      label: 'Turnover',        shortLabel: 'TO'  },
    { key: 'foul',          label: 'Personal Foul',   shortLabel: 'PF', statType: 'card' },
    { key: 'opp_shot',      label: 'Opp Shot',        shortLabel: 'OPP', statType: 'opp-shot' },
  ],
}
